import { createAction, props } from '@ngrx/store';

export const loadAutomaticCharges = createAction('[Automatic Charges] Load', props<{ partnerCode: string }>());

export const loadAutomaticChargesSuccess = createAction(
  '[Automatic Charges] Load Success',
  props<{ response: any[] }>(),
);

export const loadAutomaticChargesSuccessByKey = createAction(
  '[Automatic Charges] Load Success By Key',
  props<{ key: string; response: any[] }>(),
);

export const loadAutomaticChargesFailure = createAction('[Automatic Charges] Load Failure', props<{ error: any }>());
